import { Injectable } from '@angular/core';
import { IPaetepCfGenericMapperService } from '../../interfaces/paetep-cf-generic-mapper.service';
import { CheckboxAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/checkbox-answer-config.model';
import { EdlCfAnswerCheckboxModel, EdlCfCheckboxModel, EdlCfGenericModel, MAX_OPTION_LABEL_LENGTH, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { CustomFormQuestionType } from 'src/app/model/enum/observations/custom-forms/custom-form-question-type.enum';
import { OptionValueSubAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/sub-answer-configs/option-value-sub-answer-config.model';
import { CustomFormsHelpersService } from '../../custom-forms-helpers/custom-forms-helpers.service';

export const CHECKBOX_ANSWER_DIVIDER = ',';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfCheckboxMapperService implements IPaetepCfGenericMapperService<CheckboxAnswerConfig, EdlCfCheckboxModel<string>, string, EdlCfAnswerCheckboxModel>  {

    constructor(private customFormsHelpersService: CustomFormsHelpersService) { }

    public toEdlModel = (child: CustomFormQuestionDisplayDTO<CheckboxAnswerConfig>): EdlCfCheckboxModel<string> => {
        const options = child.answerConfig?.optionValues?.map((o, index) => {
            return {
                id: this.customFormsHelpersService.getOptionId(child, index),
                label: o.optionValue,
                value: o.optionValue
            }
        }) ?? []

        return {
            title: child.label,
            isRequired: child.required,
            options
        }
    }

    public toPaetepModel = ({
        formID, 
        sectionID,
        displayOrder,
        groupOrder,
        question
    } : {
        formID: string, 
        sectionID: string, 
        displayOrder: number,
        groupOrder: number,
        question: EdlCfGenericModel<EdlCfCheckboxModel<string>>
    }): CustomFormQuestionDisplayDTO<CheckboxAnswerConfig> =>  {
        const optionValues: OptionValueSubAnswerConfig[] = question.config.options.map(o => {
            return {
                optionValue: (o.label ?? '').substring(0, MAX_OPTION_LABEL_LENGTH)
            }
        });

        return this.customFormsHelpersService.createCustomFormQuestion<CheckboxAnswerConfig>({
            $type: CustomFormQuestionType.CHECKBOX,
            typeID: CustomFormQuestionType.CHECKBOX,
            formID,
            sectionID,
            questionID: question.id,
            readOnly: false,
            required: question.config.isRequired,
            displayOrder,
            groupOrder,
            label: (question.config.title ?? '').substring(0, MAX_TITLE_LENGTH),
            displayLabel: true,
            answerConfig: {
                optionValues
            }
        });
    }

    public toEdlAnswer = (answer: string = '', question: CustomFormQuestionDisplayDTO<CheckboxAnswerConfig>) => {
        return question.answerConfig?.optionValues
            ?.map(o => o.optionValue)
            ?.filter(o => 
                answer === o ||
                answer.startsWith(`${o}${CHECKBOX_ANSWER_DIVIDER}`) || 
                answer.endsWith(`${CHECKBOX_ANSWER_DIVIDER}${o}`) ||
                answer.includes(`${CHECKBOX_ANSWER_DIVIDER}${o}${CHECKBOX_ANSWER_DIVIDER}`)
            ) ?? [];
    }
}
